import { Flex } from '@fuxi/eevee-ui';
import classNames from 'classnames/bind';
import styles from './index.module.css';

const cx = classNames.bind(styles);

const CustomIndicator = () => {
  return (
    <Flex justifyCenter flexDirection="column" alignCenter className={cx('custom-spin-wrap')}>
      <div className={cx('custom-spin')}></div>
    </Flex>
  );
};
export default CustomIndicator;
